/**
 * @fileoverview API service for Email Sequences (drip campaigns / automation).
 */

import { BE_URLS } from "@/constants/config.js";
import axios from "@/api/axios/axios_core_deal.js";

const DEAL_HOST = BE_URLS.BACKEND_DEAL_SERVER_URL;

// ==========================================
// Sequence CRUD
// ==========================================

export async function getSequences() {
  const response = await axios.get(`${DEAL_HOST}/email-sequences`);
  return response.data;
}

export async function getSequence(id) {
  const response = await axios.get(`${DEAL_HOST}/email-sequences/${id}`);
  return response.data;
}

export async function createSequence(data) {
  const response = await axios.post(`${DEAL_HOST}/email-sequences`, data);
  return response.data;
}

export async function updateSequence(id, data) {
  const response = await axios.put(`${DEAL_HOST}/email-sequences/${id}`, data);
  return response.data;
}

export async function deleteSequence(id) {
  const response = await axios.delete(`${DEAL_HOST}/email-sequences/${id}`);
  return response.data;
}

// ==========================================
// Lifecycle
// ==========================================

export async function activateSequence(id) {
  const response = await axios.post(`${DEAL_HOST}/email-sequences/${id}/activate`);
  return response.data;
}

export async function pauseSequence(id) {
  const response = await axios.post(`${DEAL_HOST}/email-sequences/${id}/pause`);
  return response.data;
}

// ==========================================
// Enrollment
// ==========================================

export async function enrollSubscribers(id, data) {
  const response = await axios.post(`${DEAL_HOST}/email-sequences/${id}/enroll`, data);
  return response.data;
}

export async function getEnrollments(id, status) {
  const params = status ? { status } : {};
  const response = await axios.get(`${DEAL_HOST}/email-sequences/${id}/enrollments`, { params });
  return response.data;
}

export async function removeEnrollment(id, email) {
  const response = await axios.delete(`${DEAL_HOST}/email-sequences/${id}/enrollments/${encodeURIComponent(email)}`);
  return response.data;
}

// ==========================================
// Analytics
// ==========================================

export async function getSequenceStats(id) {
  const response = await axios.get(`${DEAL_HOST}/email-sequences/${id}/stats`);
  return response.data;
}
